import React, { useState } from "react";
import { P_Props } from "./CategoryForm.type";
import { SimpleModalHeader, Loading, Notification, Pulse, CategoryCard1 } from "../../components";
import { FORM_MODE, BlogCategoryApiOutputModel } from "../../../models";
import { FormUtil, FormUIUtil, loadCallback, ImageUtil } from "../../../utils";
import { Form, Field } from "react-final-form";
import { TextField, Switch, FormControlLabel } from "@material-ui/core";
import { PriorityHigh as PriorityHighIcon } from "@material-ui/icons";
const CategoryFormPresenter: React.FC<P_Props> = (props) => {
  let submit: any;
  let slugify = require("slugify");
  const [visibleDeleteModal, setVisibleDeleteModal] = useState<boolean>(false);
  const [contentNoti, setContentNoti] = useState<boolean>(false);

  const toggleDeleteModal = () => {
    setVisibleDeleteModal(!visibleDeleteModal);
  };

  const toggleContentNoti = (visible: boolean) => {
    setContentNoti(visible);
  };

  const bindingCategoryDataToForm = (data: BlogCategoryApiOutputModel[]) => {
    const tempData: BlogCategoryApiOutputModel[] = data;
    const result = Object.assign(FormUtil.buildInitDataForm(tempData, [{ key: "title" }]), {});
    return result;
  };

  return (
    <>
      <div className="category-form">
        <SimpleModalHeader
          title={props.mode === FORM_MODE.CREATE ? "New category" : "Edit Category"}
          onClose={() => {
            props.onCancel();
          }}
        />
        <div className="category-form__divide">
          <div className="category-form__language">
            <h1>Language</h1>

            {props.languageOptions.map((lang) => {
              return (
                <CategoryCard1
                  key={lang.id}
                  name={lang.name}
                  onClick={() => {
                    props.onChangeLanguage(lang.id);
                  }}
                  picture={lang.image}
                  selected={props.activeLang === lang.id}
                  buildPictureSrc={ImageUtil.buildLanguageImgSrc}
                  isAvatar={true}
                />
              );
            })}
          </div>
          <div className="category-form__container">
            <div className="category-form__box">
              {props.loading && <Loading />}
              {!props.loading && (
                <Form
                  initialValues={
                    props.initData
                      ? bindingCategoryDataToForm(props.initData)
                      : {
                          description: "",
                          status: false,
                        }
                  }
                  initialValuesEqual={() => true}
                  onSubmit={async (values, form) => {
                    props.onSubmit(values);
                  }}
                  render={({ handleSubmit, form, pristine, errors }) => {
                    if (errors) {
                      Object.keys(errors).length === 0 ? toggleContentNoti(false) : toggleContentNoti(true);
                    }
                    submit = handleSubmit;

                    return (
                      <form onSubmit={handleSubmit}>
                        <div className="category-form__title">
                          {props.mode === FORM_MODE.CREATE ? "New" : "Edit"} Category
                        </div>
                        {props.languageOptions.map((lang) => {
                          return (
                            <div
                              key={lang.id}
                              style={{
                                display: props.activeLang === lang.id ? "flex" : "none",
                              }}
                            >
                              <Field name={`title${lang.id}`} validate={FormUtil.Rule.required("Please input title")}>
                                {({ input, meta, ...rest }) => {
                                  return FormUIUtil.renderFormItem(
                                    "Category Title",
                                    <TextField
                                      {...input}
                                      {...rest}
                                      fullWidth
                                      placeholder="Enter category name..."
                                      className="form-text-field"
                                      inputProps={{ className: "input" }}
                                      variant="outlined"
                                      onChange={(e) => {
                                        input.onChange(e.target.value);
                                        const slug: string = slugify(e.target.value ?? "", {
                                          replacement: "-", // replace spaces with replacement character, defaults to `-`
                                          lower: true, // convert to lower case, defaults to `false`
                                          strict: true, // strip special characters except replacement, defaults to `false`
                                        });
                                        lang.isPrimary && form.change(`link`, slug);
                                      }}
                                      helperText={meta.touched ? meta.error : ""}
                                      error={meta.error && meta.touched}
                                    />
                                  );
                                }}
                              </Field>
                            </div>
                          );
                        })}

                        <Field name="link">
                          {({ input, meta, ...rest }) => {
                            return FormUIUtil.renderFormItem(
                              "URL",
                              <TextField
                                {...input}
                                {...rest}
                                fullWidth
                                placeholder="URL"
                                variant="outlined"
                                className="form-text-field"
                                inputProps={{ className: "input" }}
                                onChange={(e) => {
                                  return input.onChange(slugify(e.target.value ?? "", {
                                    replacement: "-", 
                                    lower: true, 
                                    strict: true, 
                                  }));
                                }}
                                helperText={meta.touched ? meta.error : ""}
                                error={meta.error && meta.touched}
                              />
                            );
                          }}
                        </Field>
                        {contentNoti && (
                          <h2 style={{ color: "red" }}>
                            Caution: You must complete content of 3 language in order to create a new category
                          </h2>
                        )}
                      </form>
                    );
                  }}
                />
              )}
            </div>
          </div>
        </div>

        <div className="category-form__footer">
          {/* {props.mode !== FORM_MODE.CREATE && (
            <button
              className="btn delete"
              onClick={(e) => {
                e.preventDefault();
                toggleDeleteModal();
              }}
            >
              Delete
            </button>
          )} */}
          {FormUIUtil.renderFormItem(
            "",
            <FormControlLabel
              control={
                <Switch
                  checked={props.categoryStatus}
                  onChange={(e) => {
                    props.onChangeCategoryStatus(e.target.checked);
                  }}
                  className="app-switch-box"
                />
              }
              label={
                <div className="form-label" style={{ marginBottom: 0 }}>
                  Publish on Website
                </div>
              }
            />
          )}
          <button
            className="btn cancel"
            onClick={(e) => {
              e.preventDefault();
              props.onCancel();
            }}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn save"
            onClick={(e) => {
              loadCallback(submit, e);
            }}
            disabled={contentNoti}
          >
            Save
          </button>
        </div>
      </div>
      <Notification
        visible={visibleDeleteModal}
        title="Delete category"
        subTitle="Are you sure you want to delete this category?"
        icon={
          <Pulse color={"red"}>
            <div className="notification-icon-box red">
              <PriorityHighIcon style={{ fontSize: "5rem", color: "#fff" }} />
            </div>
          </Pulse>
        }
        actions={
          <>
            <button
              className="category-form__delete-modal__actions__cancel"
              onClick={() => {
                toggleDeleteModal();
              }}
            >
              Cancel
            </button>
            <button
              className="category-form__delete-modal__actions__confirm"
              onClick={() => {
                toggleDeleteModal();
                props.onDeleteCategory();
              }}
            >
              Confirm
            </button>
          </>
        }
      />
    </>
  );
};

export default CategoryFormPresenter;
